import gtag from '../gtag';
import { trackEvent } from './facebook';

export function trackCheckout(tripId: number, eventCategory: 'checkout' | 'instabook checkout'): void {
  gtag('event', 'Click to checkout', {
    event_category: eventCategory,
  });
  trackEvent('InitiateCheckout', { content_ids: [tripId] });
}

export function trackRegistration() {
  gtag('event', 'New Registration', {
    event_category: 'Authentication',
  });
  trackEvent('CompleteRegistration');
}
